export interface ReserveCoinInformations {
  uid: string;
  coinFrontImageId?: string;
  coinBackImageId?: string;
  logoImageId?: string;
  coinName?: string;
  color: string;
  finish?: boolean;
  businessId?: string;
}
export interface ValidateCoinName {
  uid: string;
  name: string;
  businessId?: string;
}

export enum ResponseType {
  COIN_FRONT_UPLOAD = 'coin-front-upload',
  COIN_BACK_UPLOAD = 'coin-back-upload',
  ORIGINAL_LOGO_UPLOAD = 'original-logo-upload',
  COIN_NAME = 'coin-name',
  GENERAL = 'general'
}

export interface BaseResponse<T = any> {
  success: boolean;
  data: T;
  type: ResponseType;
}
